import { Component, input } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';

import { EntityInstanceSigner } from '@module-instance/dynamic-module/document-details/common';
import { CipoImgBase64 } from '@shared/components/img-base64/img-base64.component';

@Component({
  selector: 'cipo-signatures-tab',
  imports: [FlexLayoutModule, TranslateModule, CipoImgBase64],
  templateUrl: './signatures-tab.component.html',
})
export class SignaturesTabComponent {
  signers = input.required<EntityInstanceSigner[]>();
}
